// Intercom-specific envs
export const SUPPORT_CHAT_APP_ID = import.meta.env.REACT_APP_SUPPORT_CHAT_WIDGET_APP_ID;
export const SUPPORT_CHAT_API_BASE = import.meta.env.REACT_APP_SUPPORT_CHAT_WIDGET_API_BASE;

export const SUPPORT_CHAT_TRIGGER_ID = "repeatmd-support-chat-trigger";

export const CUSTOM_PLATFORM_NAME_PROP_NAME = "custom_repeatmd_platform_name";
export const CUSTOM_PLATFORM_ID_PROP_NAME = "custom_repeatmd_platform_id";
export const CUSTOM_PLATFORM_DOMAIN_PROP_NAME = "custom_repeatmd_platform_domain";
export const CUSTOM_IS_MULTI_PLATFORM_USER_PROP_NAME = "custom_repeatmd_is_multi_platform_user";

export const CUSTOM_USER_ROLES_PROP_NAME = "custom_repeatmd_user_roles";

export const CUSTOM_USER_CREATED_AT_PROP_NAME = "custom_repeatmd_user_created_at";

export const CUSTOM_REPEATMD_ENV = "custom_repeatmd_env";
